import { Text } from '@mantine/core';
export function RatingError(): JSX.Element {
  return <Text>There was an error uploading your rating selection</Text>;
}
